export const asyncRoutes = [
  {
    path: "/users",
    component: () => import("@/views/settings/users"),
    name: "users",
    item: {
      icon: "mdi-account-circle",
      link: "users",
      title: "users"
    },
    meta: {
      permissions: "users_view"
    }
  },
  {
    path: "/settings/users/create",
    component: () => import("@/views/settings/users/crud"),
    name: "usersCreate",

    meta: {
      permissions: "users_create"
    }
  },
  {
    path: "/settings/users/edit/:username",
    component: () => import("@/views/settings/users/crud"),
    name: "usersUpdate",
    meta: {
      permissions: "users_edit"
    }
  },
  {
    path: "/blogs",
    component: () => import("@/views/blogs"),
    name: "blogs",
    item: {
      title: "blogs",
      link: "blogs",
      icon: "mdi-account-circle"
    },
    meta: {
      permissions: "blogs_view"
    }
  },
  {
    path: "/blogs/create",
    component: () => import("@/views/blogs/crud"),
    name: "blogCreate",
    meta: {
      permissions: "blogs_create"
    }
  },
  {
    path: "/blogs/edit/:slug",
    component: () => import("@/views/blogs/crud"),
    name: "blogEdit",
    meta: {
      permissions: "blogs_edit"
    }
  },
  {
    path: "/tags",
    component: () => import("@/views/tags"),
    name: "tags",
    item: {
      icon: "mdi-tag",
      link: "tags",
      title: "tags"
    },
    meta: {
      permissions: "tags_view"
    }
  },
  {
    path: "/tags/create",
    component: () => import("@/views/tags/crud"),
    name: "tagCreate",
    meta: {
      permissions: "tags_create"
    }
  },
  {
    path: "/tags/edit/:id",
    component: () => import("@/views/tags/crud"),
    name: "tagEdit",
    meta: {
      permissions: "tags_edit"
    }
  },
  {
    path: "/teachers",
    component: () => import("@/views/teachers"),
    name: "teachers",
    item: {
      icon: "mdi-tag",
      link: "teachers",
      title: "teachers"
    },
    meta: {
      permissions: "teachers_view"
    }
  },
  {
    path: "/teachers/create",
    component: () => import("@/views/teachers/crud"),
    name: "teachersCreate",
    meta: {
      permissions: "teachers_create"
    }
  },
  {
    path: "/teachers/edit/:id",
    component: () => import("@/views/teachers/crud"),
    name: "teachersEdit",
    meta: {
      permissions: "teachers_edit"
    }
  },
  {
    path: "/teachers/:slug/contacts",
    component: () => import("@/views/teachers/contacts"),
    name: "teachersContacts"
  },
  {
    path: "/topics",
    component: () => import("@/views/topics"),
    name: "topics",
    item: {
      icon: "mdi-tag",
      link: "topics",
      title: "topics"
    },
    meta: {
      permissions: "topics_view"
    }
  },
  {
    path: "/topics/create",
    component: () => import("@/views/topics/crud"),
    name: "topicCreate",
    meta: {
      permissions: "topics_create"
    }
  },
  {
    path: "/topics/edit/:id",
    component: () => import("@/views/topics/crud"),
    name: "topicEdit",
    meta: {
      permissions: "topics_edit"
    }
  },
  {
    path: "/subjects",
    component: () => import("@/views/subjects"),
    name: "subjects",
    item: {
      icon: "mdi-flag",
      link: "subjects",
      title: "subjects"
    },
    meta: {
      permissions: "subjects_view"
    }
  },

  {
    path: "/subject/create",
    component: () => import("@/views/subjects/crud"),
    name: "subjectCreate",
    meta: {
      permissions: "subjects_create"
    }
  },
  {
    path: "/subject/edit/:id",
    component: () => import("@/views/subjects/crud"),
    name: "subjectEdit",
    meta: {
      permissions: "subjects_edit"
    }
  },
  {
    path: "/subject/:slug/exams",
    component: () => import("@/views/subjects/exams"),
    name: "subjectEdit",
    meta: {
      permissions: "subjects_edit"
    }
  },
  {
    path: "/chapters",
    component: () => import("@/views/subjects/chapters"),
    name: "chapters",
    meta: {
      permissions: "chapters_view"
    }
  },
  {
    path: "/chapters/create",
    component: () => import("@/views/subjects/chapters/crud"),
    name: "chaptersCreate",
    meta: {
      permissions: "chapters_create"
    }
  },
  {
    path: "/chapters/edit/:id",
    component: () => import("@/views/subjects/chapters/crud"),
    name: "editCreate",
    meta: {
      permissions: "chapters_edit"
    }
  },
  {
    path: "/chapters/:id/questions",
    component: () => import("@/views/subjects/chapters/questions"),
    name: "questions",
    meta: {
      permissions: "chapters/questions_view"
    }
  },
  {
    path: "/chapters/:id/questions/create",
    component: () => import("@/views/subjects/chapters/questions/crud"),
    name: "questionsCreate",
    meta: {
      permissions: "chapters/questions_create"
    }
  },
  {
    path: "/chapters/:id/questions/:slug/edit",
    component: () => import("@/views/subjects/chapters/questions/crud"),
    name: "questionsEdit",
    meta: {
      permissions: "chapters/questions_edit"
    }
  },

  {
    path: "/chapters/:id/meetings",
    component: () => import("@/views/subjects/chapters/meetings"),
    name: "meetings",
    meta: {
      permissions: "chapters/meetings_view"
    }
  },
  {
    path: "/chapters/:id/meetings/create",
    component: () => import("@/views/subjects/chapters/meetings/crud"),
    name: "meetingsCreate",
    meta: {
      permissions: "chapters/meetings_create"
    }
  },
  {
    path: "/chapters/:id/meetings/:slug/edit",
    component: () => import("@/views/subjects/chapters/meetings/crud"),
    name: "meetingsEdit",
    meta: {
      permissions: "chapters/meetings_edit"
    }
  },
  {
    path: "/chapters/:slug/inquiries",
    component: () => import("@/views/subjects/chapters/inquiries"),
    name: "inquiries",
    meta: {
      permissions: "chapters/inquiries_view"
    }
  },
  {
    path: "/subscriptions",
    component: () => import("@/views/subscriptions"),
    name: "subscriptions",
    item: {
      icon: "mdi-flag",
      link: "subscriptions",
      title: "subscriptions"
    },
    meta: {
      permissions: "subscriptions_view"
    }
  },
  {
    path: "/subscriptions/create",
    component: () => import("@/views/subscriptions/crud"),
    name: "subscriptionsCreate",
    meta: {
      permissions: "subscriptions_create"
    }
  },
  {
    path: "/subscriptions/:reference_number/chapter-subscriptions",
    component: () => import("@/views/subscriptions/chapters"),
    name: "chapterSubscriptions",
    meta: {
      permissions: "subscriptions/chapter-subscriptions_view"
    }
  },
  {
    path: "/honor-plates",
    component: () => import("@/views/honorPlates"),
    name: "honor-plates",
    item: {
      icon: "mdi-flag",
      link: "honor-plates",
      title: "honor-plates"
    },
    meta: {
      permissions: "honor-plates_view"
    }
  },
  {
    path: "/honor-plates/create",
    component: () => import("@/views/honorPlates/crud"),
    name: "honorPlatesCreate",
    meta: {
      permissions: "honor-plates_create"
    }
  },
  {
    path: "/honor-plates/:slug/edit",
    component: () => import("@/views/honorPlates/crud"),
    name: "honorPlatesEdit",
    meta: {
      permissions: "honor-plates_edit"
    }
  },
  {
    path: "/honor-plates/:slug/contacts",
    component: () => import("@/views/honorPlates/contacts"),
    name: "honorPlatesContacts",
    meta: {
      permissions: "honor-plates/contacts_view"
    }
  },

  {
    path: "/contact-message",
    component: () => import("@/views/contactMessage"),
    name: "contact-message",
    item: {
      icon: "mdi-message",
      link: "contact-message",
      title: "contact_message"
    },
    meta: {
      permissions: "contact-messages_view"
    }
  },

  {
    path: "/countries",
    component: () => import("@/views/countries"),
    name: "countries",
    meta: {
      title: "countries",
      icon: "mdi-earth-box"
    }
  },
  {
    path: "/countries/:id/states",
    component: () => import("@/views/countries/states"),
    name: "states",
    meta: {
      title: "list",
      icon: "mdi-account-circle"
    },
    hidden: true
  },
  {
    path: "/countries/:id/states/create",
    component: () => import("@/views/countries/states/crud"),
    name: "stateCreate",
    meta: {
      title: "list",
      icon: "mdi-account-circle"
    },
    hidden: true
  },
  {
    path: "/countries/:id/states/edit/:ref",
    component: () => import("@/views/countries/states/crud"),
    name: "stateEdit",
    meta: {
      title: "list",
      icon: "mdi-account-circle"
    },
    hidden: true
  },
  {
    path: "/settings",
    component: () => import("@/views/settings"),
    name: "settings",
    item: { icon: "mdi-cog", link: "settings", title: "settings" },
    meta: {
      permissions: "settings_view"
    }
  },
  {
    path: "/settings/global",
    component: () => import("@/views/settings/global"),
    name: "global",
    meta: {
      title: "global",
      icon: "mdi-earth"
    }
  },
  {
    path: "/settings/global/edit/:id",
    component: () => import("@/views/settings/global/crud"),
    name: "globalEdit",
    meta: {
      title: "global",
      icon: "mdi-earth"
    }
  },

  {
    path: "/settings/roles",
    component: () => import("@/views/settings/roles"),
    name: "roles",
    meta: {
      permissions: "roles_view"
    }
  },
  {
    path: "/settings/roles/create",
    component: () => import("@/views/settings/roles/crud"),
    name: "rolesCreate",
    meta: {
      permissions: "roles_create"
    }
  },
  {
    path: "/settings/roles/edit/:id",
    component: () => import("@/views/settings/roles/crud"),
    name: "rolesUpdate",
    meta: {
      permissions: "roles_edit"
    }
  }
];
